import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
// import { FaCheckCircle,  } from 'react-icons/fa';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import { getSectors } from '../../api/userApi';

const SurveyWrapper = styled.section`
  direction: rtl;
  width: 100%;
  max-width: 70%;
  margin: 0 auto;
  padding: 2rem;
  background: #f5f5f5;

  @media (max-width: 768px) {
    padding: 1rem;
  }

  .survey-header {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-right: 4px solid #1b8a8c;

    h1 {
      color: #1b8a8c;
      margin: 0 0 1rem 0;
      font-size: 1.8rem;
    }

    .description {
      color: #666;
      line-height: 1.8;
      margin: 0;
      font-size: 0.95rem;
    }
  }

  .scale-legend {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    h3 {
      margin: 0 0 1rem 0;
      color: #333;
      font-size: 1.1rem;
    }

    .scale-items {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      gap: 1rem;

      .scale-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem;
        background: #f5f5f5;
        border-radius: 6px;
        font-size: 0.9rem;

        .scale-number {
          background: #1b8a8c;
          color: white;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          flex-shrink: 0;
        }
      }
    }
  }

  .survey-section {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .section-title {
      color: #1b8a8c;
      font-size: 1.3rem;
      margin: 0 0 1.5rem 0;
      padding-bottom: 1rem;
      border-bottom: 2px solid #e0e0e0;
    }

    .question-item {
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }

      .question-text {
        color: #333;
        font-weight: 500;
        margin-bottom: 1rem;
        line-height: 1.6;
        display: flex;
        align-items: flex-start;
        gap: 0.75rem;

        .number {
          background: #e8f4f5;
          color: #1b8a8c;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          flex-shrink: 0;
          font-size: 0.9rem;
        }

        .text {
          flex: 1;
        }
      }

      .rating-buttons {
        display: flex;
        gap: 0.75rem;
        justify-content: flex-end;

        button {
          width: 44px;
          height: 44px;
          border-radius: 6px;
          border: 2px solid #ddd;
          background: white;
          cursor: pointer;
          font-weight: 600;
          color: #666;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            border-color: #1b8a8c;
            color: #1b8a8c;
            background: #f5f5f5;
          }

          &.selected {
            background: #1b8a8c;
            color: white;
            border-color: #1b8a8c;
          }
        }
      }
    }
  }

  .open-questions {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .section-title {
      color: #1b8a8c;
      font-size: 1.3rem;
      margin: 0 0 1.5rem 0;
      padding-bottom: 1rem;
      border-bottom: 2px solid #e0e0e0;
    }

    .open-question {
      margin-bottom: 2rem;

      &:last-child {
        margin-bottom: 0;
      }

      label {
        display: block;
        color: #333;
        font-weight: 500;
        margin-bottom: 0.75rem;
        line-height: 1.6;
      }

      textarea {
        width: 100%;
        padding: 1rem;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 0.9rem;
        font-family: inherit;
        resize: vertical;
        min-height: 100px;
        transition: all 0.3s ease;

        &:focus {
          outline: none;
          border-color: #1b8a8c;
          box-shadow: 0 0 0 2px rgba(27, 138, 140, 0.1);
        }

        &::placeholder {
          color: #999;
        }
      }
    }
  }

  .submit-section {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-top: 2rem;

    button {
      padding: 0.75rem 2rem;
      border: none;
      border-radius: 6px;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      &.submit-btn {
        background: #1b8a8c;
        color: white;

        &:hover:not(:disabled) {
          background: #15696b;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(27, 138, 140, 0.3);
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      &.reset-btn {
        background: #f5f5f5;
        color: #333;
        border: 1px solid #ddd;

        &:hover {
          background: #eee;
          border-color: #999;
        }
      }
    }
  }

  .submission-status {
    margin-top: 2rem;
    padding: 1.5rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 1rem;

    &.success {
      background: #e8f5e9;
      border: 1px solid #4caf50;
      color: #2e7d32;

      svg {
        color: #4caf50;
        font-size: 1.5rem;
      }
    }

    &.error {
      background: #ffebee;
      border: 1px solid #f44336;
      color: #c62828;

      svg {
        color: #f44336;
        font-size: 1.5rem;
      }
    }
  }

  .sector-card {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    border-right: 4px solid #1b8a8c;

    .sector-title {
      color: #1b8a8c;
      font-size: 1.2rem;
      margin: 0 0 0.5rem 0;
    }

    .sector-description {
      color: #666;
      font-size: 0.9rem;
      margin: 0 0 1rem 0;
    }

    .sector-select {
      width: 100%;
      padding: 0.75rem 1rem;
      border: 1px solid #ddd;
      border-radius: 6px;
      font-size: 1rem;
      font-family: inherit;
      direction: rtl;
      cursor: pointer;
      background: white;
      color: #333;
      transition: all 0.3s ease;

      &:focus {
        outline: none;
        border-color: #1b8a8c;
        box-shadow: 0 0 0 2px rgba(27, 138, 140, 0.1);
      }
    }

    .sector-selected {
      margin-top: 0.75rem;
      color: #1b8a8c;
      font-size: 0.9rem;
      font-weight: 500;
    }
  }

  .progress-bar {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    .progress-label {
      color: #666;
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
      display: flex;
      justify-content: space-between;

      span:last-child {
        font-weight: 600;
        color: #1b8a8c;
      }
    }

    .progress-track {
      width: 100%;
      height: 8px;
      background: #e0e0e0;
      border-radius: 4px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: #1b8a8c;
        transition: width 0.3s ease;
      }
    }
  }
`;

const SurveyPage = () => {
  const [answers, setAnswers] = useState({});
  const [openAnswers, setOpenAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [checking, setChecking] = useState(true);
  const [sector, setSector] = useState('');
  const [sectors, setSectors] = useState([]);
  const [sectorsLoading, setSectorsLoading] = useState(true);
  const [branch, setBranch] = useState('');

  const BRANCHES = ['מיון', 'שיקום הלב'];

  useEffect(() => {
    const run = async () => {
      try {
        const [statusRes, sectorsRes] = await Promise.all([
          fetch('/api/survey/me/status').then((r) => r.json()),
          getSectors(),
        ]);
        setAlreadySubmitted(Boolean(statusRes?.alreadySubmitted));
        if (sectorsRes.success) setSectors(sectorsRes.sectors);
      } finally {
        setChecking(false);
        setSectorsLoading(false);
      }
    };
    run();
  }, []);

  if (checking || sectorsLoading) return <div style={{ padding: 20 }}>טוען...</div>;

  if (alreadySubmitted) {
    return (
      <div style={{ padding: 20, direction: 'rtl' }}>
        ✅ כבר מילאת את הסקר לשנה זו. תודה!
      </div>
    );
  }

  const sections = [
    {
      id: 'part-a',
      title: "חלק א': העובד וסביבת העבודה",
      questions: [
        'עומדים לרשותי הכלים והמשאבים (טכנולוגיה, ציוד, מידע) לביצוע עבודתי בצורה יעילה.',
        'סביבת העבודה הפיזית שלי מאפשרת לי לעבוד בנוחות ובריכוז.',
        'אני מרגיש/ה בטוח/ה להביע את דעתי ולשאול שאלות ללא חשש',
        'היקף המשימות שלי תואם את שעות העבודה המוגדרות לי.',
        'תהליכי העבודה בארגון ברורים ויעילים.',
      ],
    },
    {
      id: 'part-b',
      title: "חלק ב': עבודת צוות ושייכות",
      questions: [
        'אני מרגיש/ה בנוח לבקש עזרה מחברי לצוות כשאני זקוק/ה לה.',
        'קיימת בצוות שלי אווירה של שיתוף פעולה ופרגון הדדי.',
        'אני מרגיש/ה תחושת שייכות חזקה לצוות שלי.',
        'התקשורת בתוך הצוות פתוחה, כנה ומכבדת.',
        'חברי הצוות שלי מחויבים לאיכות העבודה ולהצלחה המשותפת.',
      ],
    },
    {
      id: 'part-c',
      title: "חלק ג': תחושת נראות והערכה",
      questions: [
        'אני מרגיש/ה שהעבודה שלי משמעותית ותורמת להצלחת הארגון.',
        'אני מקבל/ת הערכה (מילולית או אחרת) כשאני מבצע/ת עבודה טובה.',
        'הארגון רואה אותי כאדם ולא רק כ"כוח עבודה".',
        'דעתי נשמעת ונלקחת בחשבון בקבלת החלטות הנוגעות לעבודתי.',
      ],
    },
    {
      id: 'part-d',
      title: "חלק ד': המנהל הישיר",
      questions: [
        'אני סומך/ת על המנהל/ת הישיר/ה שלי ועל שיקול דעתו/ה.',
        'המנהל/ת שלי קשוב/ה לצרכים ולבעיות שאני מעלה.',
        'המנהל/ת שלי מספק/ת לי משוב בונה שעוזר לי להשתפר.',
        'המנהל/ת שלי מתייחס/ת אלי בכבוד ובהוגנות.',
        'המנהל/ת שלי מעודד/ת אותי ליזום ולהביע רעיונות חדשים.',
        'המנהל/ת שלי מגבה אותי מול גורמים אחרים בארגון בעת הצורך.',
      ],
    },
    {
      id: 'part-e',
      title: "חלק ה': ההנהלה הבכירה",
      questions: [
        'יש לי אמון בהנהלה הבכירה שתוביל את הארגון להצלחה.',
        'ההנהלה הבכירה מתקשרת את מטרות הארגון והחזון בצורה ברורה ושקופה.',
        'אני מרגיש/ה שההנהלה הבכירה פועלת על פי ערכי הארגון.',
        'להנהלה הבכירה אכפת משלומם של העובדים.',
      ],
    },
    {
      id: 'part-f',
      title: "חלק ו': פיתוח מקצועי",
      questions: [
        'אני רואה לעצמי עתיד בארגון בטווח של השנתיים הקרובות.',
        'יש לי הזדמנויות ללמוד, להתפתח ולרכוש מיומנויות חדשות בארגון.',
        'הארגון משקיע בהכשרה שלי (קורסים, הדרכות, חניכה).',
      ],
    },
    {
      id: 'part-g',
      title: "חלק ז': איזון בית-עבודה",
      questions: [
        'הארגון מאפשר לי לשמור על איזון בריא בין העבודה לחיים האישיים.',
        'אני מצליח/ה להתנתק מהעבודה בשעות הפנאי שלי.',
      ],
    },
    {
      id: 'part-h',
      title: 'מדד נאמנות ושביעות רצון',
      questions: [
        'באופן כללי, אני מרוצה מהעבודה שלי בארגון.',
        'באיזו מידה תמליץ/י לחבר לעבוד בארגון שלנו? (בסולם 1-10)',
        'אני גאה לספר לאנשים שאני עובד/ת בארגון הזה.',
      ],
    },
  ];

  const openQuestions = [
    'מהו הדבר האחד שהיית משמר/ת בארגון? (מה עובד טוב?)',
    'מהו הדבר האחד שהכי חשוב לשפר בארגון?',
    'האם יש נושאים נוספים שתרצה/י להעלות?',
  ];

  const handleRating = (sectionId, questionIndex, rating) => {
    const key = `${sectionId}-${questionIndex}`;
    setAnswers({
      ...answers,
      [key]: rating,
    });
  };

  const handleOpenAnswer = (index, value) => {
    setOpenAnswers({
      ...openAnswers,
      [index]: value,
    });
  };

  const totalQuestions = sections.reduce(
    (sum, section) => sum + section.questions.length,
    0
  );
  const answeredQuestions = Object.keys(answers).length;
  const progress = Math.round((answeredQuestions / totalQuestions) * 100);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!sector) {
      setStatus({
        type: 'error',
        message: 'אנא בחר/י סקטור לפני שליחת הסקר',
      });
      return;
    }

    if (answeredQuestions === 0) {
      setStatus({
        type: 'error',
        message: 'אנא מלא לפחות שאלה אחת לפני שליחה',
      });
      return;
    }

    setLoading(true);

    try {
      const surveyData = {
        sector,
        branch,
        timestamp: new Date().toISOString(),
        sections: sections.map((section) => ({
          sectionId: section.id,
          sectionTitle: section.title,
          answers: section.questions.map((question, index) => ({
            question,
            answer: answers[`${section.id}-${index}`] || null,
          })),
        })),
        openAnswers: openQuestions.map((question, index) => ({
          question,
          answer: openAnswers[index] || '',
        })),
      };

      const response = await fetch('/api/survey/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(surveyData),
      });

      if (response.ok) {
        setStatus({
          type: 'success',
          message: 'תודה רבה! הסקר שלך נשלח בהצלחה. דעתך חשובה לנו!',
        });
        // Reset form
        setAnswers({});
        setOpenAnswers({});
        setTimeout(() => setStatus(null), 5000);
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 2000);
      } else {
        throw new Error('שגיאה בשליחת הסקר');
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'שגיאה בשליחת הסקר. אנא נסה שוב.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setAnswers({});
    setOpenAnswers({});
    setSector('');
    setBranch('');
    setStatus(null);
  };

  return (
    <SurveyWrapper>
      <button
        className='btn'
        style={{ marginBottom: '20px' }}
        onClick={() => (window.location.href = '/')}
      >
        <FaArrowRight />
        חזרה לאתר
      </button>
      <div className='survey-header'>
        <h1>🎯 סקר אקלים ארגוני בריאות 2026</h1>
        <p className='description'>
          עובדים יקרים, דעתכם חשובה לנו. הסקר שלפניכם נועד למפות את תחושותיכם
          לגבי סביבת העבודה, הניהול והתרבות הארגונית, על מנת שנוכל להשתפר ולצמוח
          יחד.
          <br />
          <br />
          <strong>הסקר הינו אנונימי לחלוטין</strong> והתשובות ישמשו לצרכי למידה
          ושיפור בלבד.
        </p>
      </div>

      <div className='progress-bar'>
        <div className='progress-label'>
          <span>התקדמות סקר</span>
          <span>{progress}%</span>
        </div>
        <div className='progress-track'>
          <div className='progress-fill' style={{ width: `${progress}%` }} />
        </div>
      </div>

      <div className='scale-legend'>
        <h3>סולם התשובות:</h3>
        <div className='scale-items'>
          <div className='scale-item'>
            <div className='scale-number'>1</div>
            <div>כלל לא מסכים/ה</div>
          </div>
          <div className='scale-item'>
            <div className='scale-number'>2</div>
            <div>לא מסכים/ה</div>
          </div>
          <div className='scale-item'>
            <div className='scale-number'>3</div>
            <div>מסכים/ה חלקית</div>
          </div>
          <div className='scale-item'>
            <div className='scale-number'>4</div>
            <div>מסכים/ה</div>
          </div>
          <div className='scale-item'>
            <div className='scale-number'>5</div>
            <div>מסכים/ה מאוד</div>
          </div>
        </div>
      </div>

      <div className='sector-card'>
        <h2 className='sector-title'>🏢 בחירת סקטור</h2>
        <p className='sector-description'>
          אנא בחר/י את הסקטור שאליו אתה/את משתייך/ת. מידע זה יסייע לנו לנתח את תוצאות הסקר לפי סקטורים.
        </p>
        <select
          className='sector-select'
          value={sector}
          onChange={(e) => setSector(e.target.value)}
        >
          <option value=''>בחר/י סקטור...</option>
          {sectors.map((s, i) => (
            <option key={i} value={s}>{s}</option>
          ))}
        </select>
        {sector && (
          <div className='sector-selected'>✓ נבחר: {sector}</div>
        )}
      </div>

      <div className='sector-card'>
        <h2 className='sector-title'>🏥 בחירת סניף</h2>
        <p className='sector-description'>
          אנא בחר/י את הסניף שבו אתה/את עובד/ת.
        </p>
        <select
          className='sector-select'
          value={branch}
          onChange={(e) => setBranch(e.target.value)}
        >
          <option value=''>בחר/י סניף...</option>
          {BRANCHES.map((b, i) => (
            <option key={i} value={b}>{b}</option>
          ))}
        </select>
        {branch && (
          <div className='sector-selected'>✓ נבחר: {branch}</div>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        {sections.map((section) => (
          <div key={section.id} className='survey-section'>
            <h2 className='section-title'>{section.title}</h2>
            {section.questions.map((question, index) => (
              <div key={`${section.id}-${index}`} className='question-item'>
                <div className='question-text'>
                  <div className='number'>{index + 1}</div>
                  <div className='text'>{question}</div>
                </div>
                <div className='rating-buttons'>
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <button
                      key={rating}
                      type='button'
                      className={
                        answers[`${section.id}-${index}`] === rating
                          ? 'selected'
                          : ''
                      }
                      onClick={() => handleRating(section.id, index, rating)}
                    >
                      {rating}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}

        <div className='open-questions'>
          <h2 className='section-title'>חלק ח': שאלות פתוחות</h2>
          {openQuestions.map((question, index) => (
            <div key={index} className='open-question'>
              <label>{question}</label>
              <textarea
                value={openAnswers[index] || ''}
                onChange={(e) => handleOpenAnswer(index, e.target.value)}
                placeholder='כתוב כאן את תשובתך...'
              />
            </div>
          ))}
        </div>

        {status && (
          <div className={`submission-status ${status.type}`}>
            {status.type === 'success' && <FaCheckCircle />}
            <span>{status.message}</span>
          </div>
        )}

        <div className='submit-section'>
          <button type='submit' className='submit-btn' disabled={loading}>
            <FaCheckCircle />
            {loading ? 'שליחה...' : 'שלח סקר'}
          </button>
          <button type='button' className='reset-btn' onClick={handleReset}>
            איפוס
          </button>
        </div>
      </form>
    </SurveyWrapper>
  );
};

export default SurveyPage;
